import {$, w} from './constants';

export function advisoryForm() {
	
	$('body').click(function() {
		
	})

}